export default __webpack_public_path__ + "static/media/exam-review-file-icon.f03c5600.svg";